export const channelLabels = {
    GREY: ['Grey'],
    GREYA: ['Grey', 'Alpha'],
    RGB: ['Red', 'Green', 'Blue'],
    RGBA: ['Red', 'Green', 'Blue', 'Alpha'],
    BINARY: ['Mask'],
};
//# sourceMappingURL=channelLabels.js.map